import { render, staticRenderFns } from "./routingrulespecific.vue?vue&type=template&id=486605fa"
import script from "./routingrulespecific.vue?vue&type=script&lang=js"
export * from "./routingrulespecific.vue?vue&type=script&lang=js"
import style0 from "./routingrulespecific.vue?vue&type=style&index=0&id=486605fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports